// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import type { RequestOptions } from '@@/plugin-request/request';

/**
 * System API Service
 */

export interface DeployNoticePayload {
  message: string;
  /** ISO 8601 — when the notice started */
  startedAt?: string;
  /** ISO 8601 — expected end time (display only) */
  expiresAt?: string;
}

export interface DeployNoticeResponse {
  status?: string;
  statusCode?: number;
  data?: {
    active: boolean;
    notice: DeployNoticePayload | null;
  };
  timestamp?: string;
}

/**
 * Get the current deploy-notice state. Used on layout mount / after reconnect to
 * sync the "server update" banner with the backend (the socket event may have
 * been missed while disconnected).
 * GET /admin/system/deploy-notice
 */
export async function getDeployNotice(options?: RequestOptions) {
  return request<DeployNoticeResponse>('/admin/system/deploy-notice', {
    method: 'GET',
    ...(options || {}),
  });
}

/** Which features this deployment has switched on. Off features hide their UI entirely. */
export interface FeatureFlags {
  sellerRebateProfile: boolean;
  imageTranslate: boolean;
  liveNowPopup: boolean;
}

export interface FeatureFlagsResponse {
  status?: string;
  statusCode?: number;
  data?: { features: FeatureFlags };
  timestamp?: string;
}

/**
 * GET /admin/system/features
 *
 * The same code runs on production and the test server; what differs is which
 * features are switched on. The admin hides the controls for anything that is off,
 * so an admin never edits a setting the server would refuse to save.
 */
export async function getFeatureFlags(options?: RequestOptions) {
  return request<FeatureFlagsResponse>('/admin/system/features', {
    method: 'GET',
    ...(options || {}),
  });
}
